import React, { useEffect, useState } from "react";
import ThankYouWrapper from "./thankYou.styles";
import { useSelector, useDispatch } from "react-redux";
import { LoanApplicationDetailsTitle } from "./loanApplicationDetailsTitle";
import { LoanDetails } from "./loanDetails";
import { useHideButton } from "../../PersonalLoan/context/formContext/submitButton";
import { Paper } from "@components/paper";
import { CheckMark } from "@components/checkMark";
import SectionHeading from "@components/sectionHeading";
import { PageWrapper } from "@containers/PageWrapper/pageWrapper";
import { ProgressionBar } from "@components/breadCrumb/progressionBar";
import ContentWrapper from "@components/contentWrapper";
import { VerifyRouteController } from "../../Verify/routing/verifyRouteController";
import useGtmPageEvent from "@hooks/useGtmPageEvent";
import startUpActions from "@redux/startup/actions";
import environmentSettings from "@src/constants/environmentSettings";

const ThankYouPage = ({
  firstName,
  lastName,
  loanAmount,
  emailAddress,
  mobilePhone,
  isVerifyThankYou,
}) => {
  const { companyName } = environmentSettings;

  const [checkMarkTicked, setCheckMarkTicked] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let timer = setTimeout(() => {
      setCheckMarkTicked(true);
    }, 2000);
    return () => {
      clearTimeout(timer);
    };
  });

  useEffect(() => {
    dispatch(startUpActions.fillForm());
  }, [dispatch]);

  useHideButton();
  useGtmPageEvent();

  const hasLoanDetails = !!firstName;

  return (
    <Paper>
      <ThankYouWrapper maxWidth="500px">
        <CheckMark checked={checkMarkTicked} />
        {isVerifyThankYou ? (
          <SectionHeading
            heading={`Thank you ${firstName}`}
            subheading="Your online application is now complete."
          />
        ) : (
          <SectionHeading
            heading={`Thank you ${firstName}`}
            subheading="Your loan application has now been received. If we require any further information, we will be in touch via email."
          />
        )}
        {hasLoanDetails && (
          <>
            <LoanApplicationDetailsTitle>
              Your loan application details are confirmed below
            </LoanApplicationDetailsTitle>
            <LoanDetails
              firstName={firstName}
              lastName={lastName}
              loanAmount={loanAmount}
              emailAddress={emailAddress}
              mobilePhone={mobilePhone}
            />
          </>
        )}
        <p>
          We will be in touch with you shortly.
          <br />
          {companyName === "Nimble" ? (
            <>Thanks for choosing {companyName}.</>
          ) : (
            <> Thanks for going forward with {companyName}.</>
          )}
        </p>
      </ThankYouWrapper>
    </Paper>
  );
};

export const ThankYou = () => {
  const { loanFormResponse, initialValue } = useSelector(
    (state) => state.loanForm
  );
  const { isVerifyPath } = useSelector((state) => state.verify);
  const { value } = loanFormResponse || {};
  const { firstName, lastName, loanAmount, emailAddress, mobilePhone } =
    value || initialValue || {};

  let isVerifyThankYou;

  if (isVerifyPath === true) {
    isVerifyThankYou = true;
  }

  return (
    <PageWrapper renderHeaderBottom={() => <ProgressionBar percent={100} />}>
      <Paper>
        <ContentWrapper>
          <ThankYouPage
            firstName={firstName || ""}
            lastName={lastName || ""}
            loanAmount={loanAmount || 0}
            emailAddress={emailAddress || ""}
            mobilePhone={mobilePhone || ""}
            isVerifyThankYou={isVerifyThankYou}
          />
        </ContentWrapper>
      </Paper>
      <VerifyRouteController />
    </PageWrapper>
  );
};
